import gsap, { Power2 } from 'gsap';
import { Basics } from '../_app/cuchillo/core/Basics';

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';

class ScrollItem__CourseList extends VScroll_Item {
  _filters;
  _courses;

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this._filters = GetBy.class('__filter', __link);
    this._courses = GetBy.class('__course', __link);

    this._click = (e) => this.filter(e);
    for (let i = 0; i < this._filters.length; i++) {
      this._filters[i].addEventListener(Basics.clickEvent, this._click);
    }

    this.onShow = () => { };
    this.onHide = () => { };
    this.onMove = () => { };
  }

  //==================================================================================================================
  //          PUBLIC
  //==================================================================================================================
  filter(e) {
    const btn = e.target;

    for (let i = 0; i < this._filters.length; i++) {
      const f = this._filters[i];

      if (f !== btn) f.classList.remove('--active');
      else f.classList.add('--active');
    }

    const filter = `categ-${btn.dataset.categ}`;

    for (let i = 0; i < this._courses.length; i++) {
      const p = this._courses[i];

      if (p.classList.contains(filter)) {
        p.style.pointerEvents = 'initial';
        gsap.to(p, {
          opacity: 1,
          duration: .4,
          ease: Power2.easeOut
        });
      } else {
        p.style.pointerEvents = 'none';
        gsap.to(p, {
          opacity: .2,
          duration: .4,
          ease: Power2.easeOut
        });
      }
    }
  }

  dispose() {
    super.dispose();
    for (let i = 0; i < this._filters.length; i++) {
      this._filters[i].removeEventListener(Basics.clickEvent, this._click);
    }
  }
}

Scroll._registerClass('CourseList', ScrollItem__CourseList);